import React from 'react'
import Magnifier from 'react-magnifier'

import { ReactComponent as CloseIcon } from 'assets/images/svg/close_circle.svg'

import styles from './NonResidentModal.module.scss'

interface Props {
  images: string[]
  onClose(): void
}
export const NonResidentImageModal: React.FC<Props> = ({ images, onClose }) => {
  const onKeyUp = React.useCallback(
    (e: KeyboardEvent) => {
      switch (e.key) {
        case 'Escape': {
          return onClose()
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [images.length],
  )

  React.useEffect(() => {
    window.addEventListener('keydown', onKeyUp)
    return () => window.removeEventListener('keydown', onKeyUp)
  }, [onKeyUp])

  return (
    <div className={styles.container}>
      <div onClick={onClose} className={styles.close}>
        <CloseIcon />
      </div>
      <div onClick={onClose} className={styles.overlay}></div>

      <div className={styles.content}>
        {images.map(imgSrc => (
          <div key={imgSrc} style={{ width: 'fit-content' }}>
            <Magnifier zoomFactor={1.3} src={imgSrc} mgShape="square" />
          </div>
        ))}
      </div>
    </div>
  )
}
